<template>
    <div class="mypooq-inner-wrap">
      <!-- 코인 영역 -->
      <section>
        <div class="mypooq-info-body">
          <div class="wrap">
            <div class="my-c-wrap">
              <h3 class="my-c-tit" tabindex="0">보유 코인 내역</h3>
              <button type="button" @click.prevent="registerCoin()" class="purple-t-btn">
                <span>코인 충전</span>
              </button>
              <div class="my-c-top" tabindex="0">
                <ul>
                  <li>
                    <div>
                      <span>총코인</span>
                      <strong>{{ totalCoin | setNumberCommas }}</strong>
                    </div>
                  </li>
                  <li>
                    <div>
                      <span>충전 코인</span>
                      <strong>{{ chargedCoin | setNumberCommas }}</strong>
                    </div>
                  </li>
                  <li>
                    <div>
                      <span>보너스 코인</span>
                      <strong>{{ bonusCoin | setNumberCommas }}</strong>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="my-c-wrap">
              <ul class="my-sub-nav">
                <li>
                  <button type="button" :class="isChargedMode ? 'my-sub-nav-on' : ''"
                          @click.prevent="setTab('charged')">적립 코인</button>
                </li>
                <li>
                  <button type="button" :class="isExpiredMode ? 'my-sub-nav-on' : ''"
                          @click.prevent="setTab('expire')">소진 코인</button>
                </li>
              </ul>
              <template v-if="!isLoading && chargeCoinHistoryList.length > 0">
                <table class="my-c-table">
                  <caption class="blind">{{captionText}}</caption>
                  <colgroup v-if="isChargedMode">
                    <col style="width: 110px;">
                    <col style="width: 230px;">
                    <col style="width: 230px;">
                    <col style="width: 110px;">
                    <col style="width: 150px;">
                    <col style="width: 150px;">
                    <col style="width: 110px;">
                    <col style="width: 150px;">
                  </colgroup>
                  <colgroup v-if="isExpiredMode">
                    <col style="width: 140px;">
                    <col>
                    <col style="width: 140px;">
                    <col style="width: 180px;">
                  </colgroup>
                  <thead>
                  <tr>
                    <template v-if="isChargedMode">
                      <th>충전금액</th>
                      <th>코인명</th>
                      <th>지급사유</th>
                      <th>잔여코인</th>
                      <th>충전일</th>
                      <th>만료일자</th>
                      <th>결제수단</th>
                      <th>자동결제</th>
                    </template>
                    <!--
                    * 2월 반영 예정
                    <th v-if="viewType === 'charged'">결제수단</th>
                    -->
                    <template v-if="isExpiredMode">
                      <th>소진금액</th>
                      <th><p class="al">사용내역</p></th>
                      <th>상태</th>
                      <th>일자</th>
                    </template>
                  </tr>
                  </thead>
                  <!-- 적립 코인 -->
                  <tbody v-if="isChargedMode">
                    <tr v-for="(chargedCoin, index) in chargeCoinHistoryList" :key="index">
                      <td>{{ chargeCoin(chargedCoin) | setNumberCommas }}</td>
                      <td>{{ title(chargedCoin) }}</td>
                      <td>{{ description(chargedCoin) }}</td>
                      <td>{{ remainCoin(chargedCoin) | setNumberCommas }}</td>
                      <td>{{ startDateTime(chargedCoin) }}</td>
                      <td>{{ endDateTime(chargedCoin) }}</td>
                      <td>
                        <span class="table-inner-wrap">
                         <span>{{ paymentMethod(chargedCoin) }}</span>
                        </span>
                      </td>
                      <td>
                        <span class="table-inner-wrap">
                          <template v-if="autoPayment(chargedCoin) === 'true'">
                            <template v-if="isRequesting">
                              <span>처리중</span>
                            </template>
                            <template v-if="!isRequesting">
                              <template v-if="autoPaymentStatus(chargedCoin) === 'y'">
                                <span>자동결제 이용중</span>
                                <button class="pay-btn" @click.prevent="cancelSubscription(chargedCoin.paymentid)">자동결제 해지</button>
                              </template>
                              <template v-if="autoPaymentStatus(chargedCoin) === 'n'">
                                <span>해지 신청 완료</span>
                                <button class="pay-cancel-btn" @click.prevent="revokeSubscription(chargedCoin.paymentid)">해지 취소</button>
                              </template>
                            </template>
                          </template>
                          <template v-else>
                            <span>자동결제</span>
                            <span>대상이 아닙니다.</span>
                          </template>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                  <!-- 소진 코인 -->
                  <tbody v-else>
                  <tr v-for="(usedCoin, index) in chargeCoinHistoryList" :key="index"
                      :class="expire(usedCoin) === 'y' ? 'coin-expire' : ''">
                    <td>{{ chargeCoin(usedCoin) | setNumberCommas }}</td>
                    <td><p class="al">{{ title(usedCoin) }}</p></td>
                    <td>{{ expire(usedCoin) === 'y' ? '만료' : '사용' }}</td>
                    <td>{{ dateTime(usedCoin) }}</td>
                  </tr>
                  </tbody>
                </table>

                <paging-component :current-page="currentPage"
                                  :page-count="pageCount" :limit="limit" :paging-count="pagingCnt"
                                  wrapper-class="paging-type02" />
              </template>

              <div v-if="!isLoading && chargeCoinHistoryList.length === 0" class="my-c-empty">
                <empty-list :text="emptyText"></empty-list>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 코인 영역 -->

    </div>
</template>

<script>
import PagingComponent from '@/components/common/PagingComponent'
import {
  getMycoinListCharged,
  getMycoinListExpired,
  getMycoinSummary,
  postMypurchasePassCancel
} from '@/common/utils/request'
import { setNumberCommas, showCoinPopup, scrollTop, titleTagNameChange } from '@/common/utils/common'
import fp from 'lodash/fp'
import EmptyList from '@/components/mypooq/EmptyList'
import _ from 'lodash'
import constant from '@/common/resources/constant'
import cookie from '@/common/utils/cookie'
import { autoLoginSetting } from '@/common/utils/login'
const CANCEL_SUBSCRIPTION = '0'
const REVOKE_SUBSCRIPTION = '1'
const CHARGED_VIEW = 'charged'
const EXPIRE_VIEW = 'expire'
export default {
  data () {
    return {
      userCoinInfo: {},
      chargeCoinHistoryList: [],
      viewType: CHARGED_VIEW,
      currentPage: 1,
      pagingCnt: 10,
      limit: 15,
      pageCount: 0,
      isLoading: true,
      isRequesting: false
    }
  },
  filters: {
    setNumberCommas
  },
  components: {
    PagingComponent,
    EmptyList
  },
  computed: {
    totalCoin () {
      return this.userCoinInfo.totalcoin || 0
    },
    chargedCoin () {
      return this.userCoinInfo.chargedcoin || 0
    },
    bonusCoin () {
      return this.userCoinInfo.bonuscoin || 0
    },
    isChargedMode () {
      return this.viewType === CHARGED_VIEW
    },
    isExpiredMode () {
      return this.viewType === EXPIRE_VIEW
    },
    emptyText () {
      return this.isChargedMode ? '적립 코인이 없어요' : '소진된 코인이 없어요.'
    },
    captionText () {
      return this.isChargedMode ? '적립 코인 내역' : '소진 코인 내역'
    }
  },
  methods: {
    setTab (type) {
      const getChangedQuery = fp.flow(
        fp.omit('page'),
        fp.set('viewType', type)
      )
      this.$router.push({ path: this.$route.path, query: getChangedQuery(this.$route.query) })
    },
    registerCoin () {
      showCoinPopup({ returnUrl: `${location.origin}/callback.html?action=ClosePopupAndReload` })
    },
    changeSubscriptionStatus (paymentid, status) {
      return postMypurchasePassCancel({ productType: 'coin', keyId: paymentid, status })
    },
    cancelSubscription (paymentid) {
      if (confirm(constant.MSG_MYPOOQ_CONFIRM_COIN_UNSUBSCRIBE)) {
        this.isRequesting = true
          this.changeSubscriptionStatus(paymentid, CANCEL_SUBSCRIPTION).then(() => {
            setTimeout(() => {
              this.setData()
              this.isRequesting = false
            }, 2000)
          })
      }
    },
    revokeSubscription (paymentid) {
      if (confirm(constant.MSG_MYPOOQ_CONFIRM_COIN_REVOKE_SUBSCRIBE)) {
        this.isRequesting = true
          this.changeSubscriptionStatus(paymentid, REVOKE_SUBSCRIPTION).then(() => {
            setTimeout(() => {
              this.setData()
              this.isRequesting = false
            }, 2000)
          })
      }
    },
    setData () {
      this.isLoading = true
      this.currentPage = Number(_.get(this.$route, ['query', 'page'], '1'))
      this.viewType = _.get(this.$route, ['query', 'viewType'], 'charged')
      const offset = this.limit * (this.currentPage - 1)
      const getData = response => response.data
      const setDataList = data => { this.chargeCoinHistoryList = _.get(data, 'list', []); return data }
      const setPageCount = data => { this.pageCount = Number(_.get(data, 'pagecount', '0')); return data }
      const loadComplete = () => { this.isLoading = false }
      const coinResponseProcessor = fp.flow(getData, setDataList, setPageCount, loadComplete)
      const params = { offset, limit: this.limit, orderby: 'new' }
      const reqFn = this.viewType === 'charged' ? getMycoinListCharged : getMycoinListExpired
      reqFn(params).then(coinResponseProcessor)
      getMycoinSummary().then(({ data }) => {
        this.userCoinInfo = data
      })
      scrollTop()
    },
    paymentMethod (coin) {
      return _.get(coin, 'paymentmethod', '') === '' ? '-' : _.get(coin, 'paymentmethod', '')
    },
    title (coin) {
      return _.get(coin, 'title', '')
    },
    description (coin) {
      return _.get(coin, 'description', '')
    },
    remainCoin (coin) {
      return _.get(coin, 'remaincoin', 0)
    },
    startDateTime (coin) {
      return _.get(coin, 'startdatetime', '')
    },
    endDateTime (coin) {
      return _.get(coin, 'enddatetime', '')
    },
    autoPayment (coin) {
      return _.get(coin, 'autopayment', 'false')
    },
    autoPaymentStatus (coin) {
      return _.get(coin, 'autopaymentstatus', '')
    },
    expire (coin) {
      return _.get(coin, 'expire', 'n').toLowerCase()
    },
    chargeCoin (coin) {
      return _.get(coin, 'chargecoin', 0)
    },
    dateTime (coin) {
      return _.get(coin, 'datetime', '')
    },
    postMessage (e) {
      if (e.origin === location.origin && e.data === 'voucherAutoLogin') {
        const credential = cookie.getCredential()
        const isMultiLine = Number(cookie.userInfo('profilecount')) !== 1
        autoLoginSetting(credential, isMultiLine).then(() => {
          location.reload()
        })
      }
    }
  },
  created () {
    window.addEventListener('message', this.postMessage)
    this.$nextTick(() => {
      this.setData()
    })
    titleTagNameChange('코인내역 : 웨이브 MY')
  },
  beforeDestroy () {
    window.removeEventListener('message', this.postMessage)
  }
}
</script>
